import { createReceiveReducer, mergeReducers } from 'utils/redux'

import callReportsEpic from './callReports/epic'
import callReports from './callReports/reducer'
import conversationReportsEpic from './conversationReports/epic'
import conversationReports from './conversationReports/reducer'
import cutovers from './cutovers/reducer'
import emailCampaigns from './emailCampaigns/reducer'
import filter from './filter/reducer'
import playbooksEpic from './playbooks/epic'
import playbooks from './playbooks/reducer'
import serviceReportsEpic from './serviceReports/epic'
import serviceReports from './serviceReports/reducer'

const classifications = createReceiveReducer([], 'classifications')
const inboxes = createReceiveReducer([], 'inboxes')
const tags = createReceiveReducer([], 'tags')
const teams = createReceiveReducer([], 'teams')

export const reducers = mergeReducers({
  classifications,
  conversationReports,
  callReports,
  filter,
  inboxes,
  playbooks,
  tags,
  teams,
  cutovers,
  emailCampaigns,
  serviceReports,
})

export const epics = [
  conversationReportsEpic,
  serviceReportsEpic,
  callReportsEpic,
  playbooksEpic,
]
